import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ApiPurpleFitCompleteRegistrationRequest, ApiPurpleFitRegisterRequest, ApiPurpleFitUpdateUserInfoRequest, PRPVUserFull } from '../../../core-modules/sdk';
import { CommonModule } from '@angular/common';
import { PurpleTranslationPipe, PurpleTranslationService } from '@purple-lib/purple-translations-core';
import { PurpleFormComponent, PurpleFormFieldsGroup, PurpleSimpleButtonComponent } from '@purple-lib/purple-ui-widgets';
import { PurpleUserService, LoginType } from '@purple-lib/purple-users-core';
import { PurpleBreakpointsService } from '@purple-lib/purple-utilities';
import { PurpleEditableImageDirective } from '@purple-lib/purple-edit-medias';
import { PurpleEditableTextDirective } from '@purple-lib/purple-edit-translations';
import { PurpleFitCoreTranslations } from '../../../core-modules/constants/purple-fit-core-translations';

@Component({
  selector: 'app-request-reset-password',
  templateUrl: './request-reset-password.component.html',
  styleUrls: ['../authentication.scss', './request-reset-password.component.scss'],
  imports: [CommonModule, FormsModule, PurpleTranslationPipe, PurpleEditableTextDirective, PurpleFormComponent, PurpleSimpleButtonComponent, PurpleEditableImageDirective]
})
export class RequestResetPasswordComponent implements OnInit {
  protected readonly T = PurpleFitCoreTranslations;

  constructor(private fb: FormBuilder, public breakSvc: PurpleBreakpointsService,
    private userSvc: PurpleUserService<PRPVUserFull, ApiPurpleFitRegisterRequest, ApiPurpleFitCompleteRegistrationRequest, ApiPurpleFitUpdateUserInfoRequest>, public tsvc: PurpleTranslationService,
    private router: Router) {
    this.validateForm = this.fb.group({});
  }
  validateForm!: FormGroup;
  purpleFormFieldGroups: PurpleFormFieldsGroup[] | undefined;
  rememberCheck: boolean = true;
  otherLoginLineWidth: number = 10;
  otherLoginTextw: number = 0;
  isLoading: boolean = false;

  ngOnInit() {
    this.purpleFormFieldGroups = [
      {
        fieldGroupNumber: 1,
        fieldGroupBootstrapColumn: 12,
        fieldGroupPaddingLeft: false,
        fieldGroupPaddingRight: false,
        formFieldFormGroup: this.validateForm,
        formFields: [
          {
            fieldType: 'input-text',
            fieldControlName: 'email',
            fieldBootstrapColumn: 12,
            fieldName: this.tsvc.getTranslationValue(this.T.login_page_form_email, []),
            fieldPlaceholder: "",
            fieldValue: undefined,
            fieldIsRequired: true,
            fieldPaddingLeft: false,
            fieldPaddingRight: false,
            fieldCustomValidators: [Validators.email],
            fieldCustomValidatorErrors: [{ errorId: "email", text: this.tsvc.getTranslationValue(this.T.invalid_email_validator_error_text) }]
          }
        ]
      }
    ]
  }

  //return basic observable

  async requestResetPassword() {
    this.isLoading = true;
    for (const i in this.validateForm.controls) {
      this.validateForm.controls[i].markAsDirty();
      this.validateForm.controls[i].updateValueAndValidity();
    }

    if (this.validateForm.valid) {
      await this.userSvc.requestResetPassword(LoginType.Email, this.validateForm.controls["email"].value, undefined, async (_: boolean) => {
        await this.router.navigate([this.tsvc.currentLanguage(), 'login']);
      });
    }
    this.isLoading = false;
  }

}
